import { SuspenseErrorBoundary } from 'components/SuspenseErrorBoundary'
import { Suspense, lazy } from 'react'

const MaterialPdfDialog = lazy(() => import('./MaterialPdfDialog'))

export const LazyMaterialPdfDialog = ({
  src,
  inline,
  onDismiss,
}: {
  src: string
  inline?: boolean
  onDismiss?: () => void
}) => {
  return (
    <SuspenseErrorBoundary>
      <Suspense fallback={<div>Loading...</div>}>
        <MaterialPdfDialog src={src} inline={inline} onDismiss={onDismiss} />
      </Suspense>
    </SuspenseErrorBoundary>
  )
}
